import { Component, OnInit, Input, Output, EventEmitter, } from '@angular/core';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss']
})
export class ButtonComponent implements OnInit {

  @Input()
  text = 'button'

  @Input()
  outline = false

  @Input()
  leftIconPath = null

  @Input()
  leftIconSecondaryPath = null

  @Input()
  rightIconPath = null

  @Input()
  rightIconSecondaryPath = null

  @Input()
  size = 'md'

  @Input()
  selectMenuClick = ''

  @Output() click = new EventEmitter()

  isHover = false

  constructor() { }

  _onHover(status) {
    this.isHover = status
  }

  _onClick(event) {
    this.click.emit(event)
  }

  ngOnInit() {
  }

}
